export const HEADER_HEIGHT = 62;
export const SIDEBAR_WIDTH = 230;
/** The rendered sidebar width. The number above is only the fallback — the
 *  Appearance page drives `--nav-width`, so anything that lays out against the
 *  sidebar must read THIS, or the page and the rail disagree by however much
 *  the tenant moved the slider. */
export const SIDEBAR_WIDTH_VAR = `var(--nav-width, ${SIDEBAR_WIDTH}px)`;
/** Closed, the sidebar is an icon rail: one 36px target with a little air
 *  around it, and nothing else — anything wider is empty column. */
export const SIDEBAR_COLLAPSED_WIDTH = 56;
export const SIDEBAR_TRANSITION = 'cubic-bezier(0.685, 0.0473, 0.346, 1)';

/**
 * The one motion for opening and closing the rail. Every piece that moves with
 * it — the rail, the header's logo block, the page's left margin — uses THIS
 * string and animates only the property that actually changes. Two elements on
 * different durations, or on `all`, read as two separate animations chasing
 * each other, which is exactly what this replaces.
 */
// 320ms, not 520: the page's left margin moves with the rail, and every frame
// of that re-lays out the page (a whole grid, on the travel file list) — the
// shorter the motion, the fewer of those frames and the less it stutters.
export const SIDEBAR_MOTION = '320ms cubic-bezier(0.32, 0.72, 0, 1)';

/** The full menu and the icon rail cross-fade inside the moving rail. */
export const SIDEBAR_FADE_DURATION = '200ms';
export const SIDEBAR_FADE = `${SIDEBAR_FADE_DURATION} ease`;
